module.exports = __webpack_public_path__ + "img/blinkbox-preview-thumb.11e0c807.jpg";